import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from 'src/app/_service/user.service';
import { CompanyService } from 'src/app/_service/company.service';
import { TenantService } from 'src/app/_service/tenant.service';
import * as routing from '../../../_model/routing';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/_service/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { getTenantData } from 'src/app/_model/tenant';
import { USER_ROLES } from 'src/app/_model/string_literal';

@Component({
  selector: 'app-user-preview',
  templateUrl: './user-preview.component.html',
  styleUrls: ['./user-preview.component.css']
})
export class UserPreviewComponent implements OnInit, OnDestroy {
  currUser: any = {};
  currCompany: any;
  isGlobalAdmin: boolean = false;
  selectedRole: any;
  visible: boolean = false;
  currTenant: string | null | undefined = "";
  currTenantName: string | undefined = "";
  tenantList: getTenantData[] = [];

  roles = USER_ROLES;

  constructor(
    private router: Router,
    private userService: UserService,
    private companyService: CompanyService,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private tenantService: TenantService,
    public auth: AuthService,
  ) { }

  ngOnInit(): void {
    if (!this.userService.editUserFlag) {
      this.getUser();
    } else {
      this.initiateUser();
    }
  }

  ngOnDestroy(): void {
    this.userService.editUserFlag = false;
  }

  getUser() {
    const currUserId = window.location.pathname.split('/').at(-1);
    this.userService.selectedUserID = String(currUserId);
    this.userService.editUserFlag = true;
    this.userService.getUserById(currUserId).subscribe({
      next: async(value: any) => {
        this.userService.editUserData = value;
        this.initiateUser();
      },
      error: (error) => {
        console.error('Error fetching user:', error);
      },
    });
  }

  resetEditUser() {
    this.userService.resetSelectedUserID();
    this.userService.resetEditUser();
  }

  initiateUser() {
    this.currUser = this.userService.editUserData;
    this.tenantList = this.tenantService.tenantList;
    this.currCompany = this.companyService.companyList.find(c => c.id === this.currUser.company_id);
    this.isGlobalAdmin = this.currUser.role_id === 3;
    this.selectedRole = this.roles.find(role => role.id === this.currUser.role_id);
    this.currTenantName = this.currUser.role_id === 3 ? "" : this.tenantList.find(t => t.id === this.currUser.tenant_id)?.name;
  }

  onClickUser() {
    this.resetEditUser();
    this.router.navigate([routing.UserList]);
  }

  onClickEdit() {
    if (this.auth.isYakuin) {
      window.alert(this.translate.instant("noPermission"));
      return;
    }
    this.router.navigate([routing.UserEdit + "/" + this.userService.selectedUserID]);
  }

  copyItem(item: string, msg: string) {
    navigator.clipboard.writeText(item);

    this.translate.get(msg).subscribe((translatedText: string) => {
      this.snackBar.open(translatedText, "Close", {
        duration: 1300,
        panelClass: ["copy-msg"],
      });
    });
  }

  getCurrTenantName() {
    return this.isGlobalAdmin
      ? this.selectedRole?.name
      : this.currTenantName || "No tenant";
  }

  onRoleChange(event: any) {
    this.isGlobalAdmin = event?.value?.id === 3 ? true : false;
  }
}
